import script from "./ViewForgotPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewForgotPassword.vue?vue&type=script&setup=true&lang=js"

import "./ViewForgotPassword.vue?vue&type=style&index=0&id=53eb544b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53eb544b"]])

export default __exports__